module.exports = __webpack_public_path__ + "static/kilgore-45dd62abb90798bcee5fbef14dc4753b.jpg";